import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { EMPTY } from 'rxjs/internal/observable/empty';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QsHttpService {
  protected readonly _httpClient: HttpClient = inject(HttpClient);
  protected readonly _router: Router = inject(Router);

  public http<T>(method: string, url: string, body?: any): Observable<T> {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: environment.authorizationBearer,
    };

    return this._httpClient.request<T>(method, `${environment.strapiApiUrl}/api${url}`, { body, headers })
      .pipe(
        catchError(this._catchError.bind(this)),
      );
  }

  public get<T>(url: string): Observable<T> {
    return this.http<T>('GET', url, null)
      .pipe(
        catchError(this._catchError.bind(this)),
      );
  }

  public post<T>(url: string, body: any): Observable<T> {
    return this.http<T>('POST', url, body)
      .pipe(
        catchError(this._catchError.bind(this)),
      );
  }

  private _catchError(error: any): Observable<never> {
    this._router.navigate(['an-error-has-occurred']);
    return EMPTY;
  }
}
